<script>
  import DashboardNotificationItem from '../components/Dashboard/DashboardNotificationItem.svelte';
  import NavLink from '../components/NavLink.svelte';
  import AlertModal from '../components/Alert/Alert.svelte';
  import { client } from 'root/api/index.js';
  import { onMount, onDestroy, getContext } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { configItem } from 'components/Helper.js';
  import { checkRole } from '../stores/auth.js';
  import { Popover } from 'bootstrap';
  import { resetDashboardData } from '../stores/dashboard';
  const showDialog = getContext('showDialog');
  let notificationData = [];

  const getNotificationSummary = () => {
    notificationData = [];
    client
      .notificationSummary()
      .then((response) => {
        notificationData = response.data;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  onMount(() => {
    getNotificationSummary();
  });
  let calendarComponentRef;
</script>

<div class="d-flex flex-column h-100">
  <div class="page-content">
    <div class="container">
      <div class="dashboard-content">
        <div class="row">
          <div class="col-md-12 text-center">
            <h1 class="dashboard-heading">What do you want to do?</h1>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button
              on:click={() => {
                navigate(`/client`);
              }}
              class="color-blue bg-transparent border-0 w-100 p-0"
            >
              <div class="home-block bg-white">
                <div class="creat-new-client d-flex align-items-center justify-content-center mb-3">
                  <img
                    alt=""
                    class="create-task mb-0"
                    src="./images/user-blue.svg"
                  />
                </div>
                <h3 class="card-label font-weight-bolder text-dark mb-1 text-start">
                  View Clients
                </h3>
                <div class="d-flex flex-row justify-content-between align-items-center">
                  <span class="secondary-text">Click here</span>
                  <img
                    class="arrow-icon"
                    alt=""
                    src="./images/right-arrow.svg"
                  />
                </div>
              </div>
            </button>
          </div>
          <div class="col">
            <button
              on:click={() => {
                navigate(`/redirect/task#action=addTask`);
              }}
              class="bg-transparent border-0 w-100 p-0"
            >
              <div class="home-block bg-white">
                <div class="add-new-task d-flex align-items-center justify-content-center mb-3">
                  <img
                    alt=""
                    class="create-task mb-0"
                    src="./images/add-task.svg"
                  />
                </div>
                <h3 class="card-label font-weight-bolder text-dark mb-1 text-start">
                  Generate a New Task
                </h3>
                <div class="d-flex flex-row justify-content-between align-items-center">
                  <span class="secondary-text">Click here</span>
                  <img
                    class="arrow-icon"
                    alt=""
                    src="./images/right-arrow.svg"
                  />
                </div>
              </div>
            </button>
          </div>
          <div class="col">
            <button
              on:click={() => {
                resetDashboardData();
                setTimeout(() => {
                  navigate(`/redirect/task#action=scheduleTask`);
                }, 250);
              }}
              class="bg-transparent border-0 w-100 p-0"
            >
              <div class="home-block bg-white w-100">
                <div class="review-new-task d-flex align-items-center justify-content-center mb-3">
                  <img
                    alt=""
                    class="create-task mb-0"
                    src="./images/review-to-do-task.svg"
                  />
                </div>
                <h3 class="card-label font-weight-bolder text-dark mb-1 text-start">
                  Review Upcoming Tasks
                </h3>
                <div class="d-flex flex-row justify-content-between align-items-center">
                  <span class="secondary-text">Click here</span>
                  <img
                    class="arrow-icon"
                    alt=""
                    src="./images/right-arrow.svg"
                  />
                </div>
              </div>
            </button>
          </div>
          <div class="col">
            <button
              on:click={() => {
                resetDashboardData();
                setTimeout(() => {
                  navigate(`/redirect/task#action=openTask`);
                }, 250);
              }}
              class=" bg-transparent border-0 w-100 d-flex p-0"
            >
              <div class="home-block bg-white w-100">
                <div class="review-open-task d-flex align-items-center justify-content-center mb-3">
                  <img
                    alt=""
                    class="create-task mb-0"
                    src="./images/review-open-task.svg"
                  />
                </div>
                <h3 class="card-label font-weight-bolder text-dark mb-1 text-start">
                  Review Open Tasks
                </h3>
                <div class="d-flex flex-row justify-content-between align-items-center">
                  <span class="secondary-text">Click here</span>
                  <img
                    class="arrow-icon"
                    alt=""
                    src="./images/right-arrow.svg"
                  />
                </div>
              </div>
            </button>
          </div>

          {#if checkRole(configItem.roleIndex.user) == false}
            <div class="col">
              <button
                on:click={() => {
                  resetDashboardData();
                  setTimeout(() => {
                    navigate(`/redirect/task#action=managerTask`);
                  }, 250);
                }}
                class="bg-transparent border-0 w-100 p-0"
              >
                <div class="home-block bg-white">
                  <div
                    class="review-task-staff d-flex align-items-center justify-content-center mb-3"
                  >
                    <img
                      alt=""
                      class="create-task mb-0"
                      src="./images/task-staff.svg"
                    />
                  </div>
                  <h3 class="card-label font-weight-bolder text-dark text-start mb-1">
                    Review Open Tasks for all my Staff
                  </h3>
                  <div class="d-flex flex-row justify-content-between align-items-center">
                    <span class="secondary-text">Click here</span>
                    <img
                      class="arrow-icon"
                      alt=""
                      src="./images/right-arrow.svg"
                    />
                  </div>
                </div>
              </button>
            </div>
          {/if}
        </div>

        <div class="notification-task">
          <div class="d-flex flex-row justify-content-between">
            <h3>Notification Summary</h3>
            <NavLink
              to="/notifications"
              Style="border-0 color-blue">View All</NavLink
            >
          </div>
          {#if notificationData.length == 0}
            <div
              class="d-flex bg-white box-shadow rounded align-items-center justify-content-center d-flex flex-column no-notifications"
            >
              <svg
                fill="#787e8d"
                id="Capa_1"
                enable-background="new 0 0 512 512"
                height="40"
                viewBox="0 0 512 512"
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="m450.201 407.453c-1.505-.977-12.832-8.912-24.174-32.917-20.829-44.082-25.201-106.18-25.201-150.511 0-.193-.004-.384-.011-.576-.227-58.589-35.31-109.095-85.514-131.756v-34.657c0-31.45-25.544-57.036-56.942-57.036h-4.719c-31.398 0-56.942 25.586-56.942 57.036v34.655c-50.372 22.734-85.525 73.498-85.525 132.334 0 44.331-4.372 106.428-25.201 150.511-11.341 24.004-22.668 31.939-24.174 32.917-6.342 2.935-9.469 9.715-8.01 16.586 1.473 6.939 7.959 11.723 15.042 11.723h109.947c.614 42.141 35.008 76.238 77.223 76.238s76.609-34.097 77.223-76.238h109.947c7.082 0 13.569-4.784 15.042-11.723 1.457-6.871-1.669-13.652-8.011-16.586zm-223.502-350.417c0-14.881 12.086-26.987 26.942-26.987h4.719c14.856 0 26.942 12.106 26.942 26.987v24.917c-9.468-1.957-19.269-2.987-29.306-2.987-10.034 0-19.832 1.029-29.296 2.984v-24.914zm29.301 424.915c-25.673 0-46.614-20.617-47.223-46.188h94.445c-.608 25.57-21.549 46.188-47.222 46.188zm60.4-76.239c-.003 0-213.385 0-213.385 0 2.595-4.044 5.236-8.623 7.861-13.798 20.104-39.643 30.298-96.129 30.298-167.889 0-63.417 51.509-115.01 114.821-115.01s114.821 51.593 114.821 115.06c0 .185.003.369.01.553.057 71.472 10.25 127.755 30.298 167.286 2.625 5.176 5.267 9.754 7.861 13.798z"
                /></svg
              >
              <span class="d-block mt-2 font-size-12 color-lead"
                >You don't have any notification yet</span
              >
            </div>
          {:else}
            {#each notificationData as item}
              <DashboardNotificationItem
                message={item.message}
                item={item}
                timeAgoStr={item.timeAgoStr}
                time={item.timeDisplayTZ}
                url={item.url}
              />
            {/each}
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>

<AlertModal />

<style lang="scss">
  .dashboard-heading {
    font-size: 26px;
    color: #181c32;
    margin-top: 80px;
  }

  .dashboard-subheading {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 60px;
    color: #b5b5c3 !important;
  }
  .home-block {
    padding: 1.6rem 1.3rem;
    box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
    border-radius: 6px;
    transition: 0.3s;
    .creat-new-client {
      width: 80px;
      height: 80px;
      background-color: #206bc410;
      border-radius: 10px;
      margin-bottom: 20px;
    }
    .add-new-task {
      width: 80px;
      height: 80px;
      background-color: #fff4de !important;
      border-radius: 10px;
      margin-bottom: 20px;
    }
    .review-new-task {
      width: 80px;
      height: 80px;
      background-color: #c9f7f5 !important;
      border-radius: 10px;
      margin-bottom: 20px;
    }
    .review-open-task {
      width: 80px;
      height: 80px;
      background-color: #ffe2e5 !important;
      border-radius: 10px;
      margin-bottom: 20px;
    }
    .review-task-staff {
      width: 80px;
      height: 80px;
      background-color: #eee5ff !important;
      border-radius: 10px;
      margin-bottom: 20px;
    }

    &:hover {
      box-shadow: 0 6px 12px rgba(140, 152, 164, 0.25) !important;
    }
    .text-dark {
      color: #181c32 !important;
    }
    h3 {
      font-size: 16px;
      font-weight: 600 !important;
      height: 40px;
    }
    .arrow-icon {
      width: 20px;
    }
    .secondary-text {
      color: #b5b5c3 !important;
    }
    .create-task {
      width: 42px;
      height: 42px;
      margin-bottom: 25px;
    }
  }

  .notification-task {
    margin-top: 60px;
    h3 {
      font-size: 16px;
    }
  }

  .no-notifications {
    height: 200px;
  }
</style>
